<template>
    <aside class="col-12 col-md-4 col-lg-3 col-xl-3 aside">
        <div class="sidebar-box border-0 pb-0">
            <strong class="h2 text-uppercase">Download app</strong>
            <div class="sidebar-box-inner">
                <ul class="download-apps-btn">
                    <li>
                        <a target="_blank" href="https://apps.apple.com/gb/app/planetcricket/id1562153858">
                            <img width="135" height="40" class="lazyload" :src="require('@/assets/images/app-store.png')" alt="app store" /></a>
                    </li>
                    <li>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.sportcc.planetcricket">
                            <img width="135" height="40" class="lazyload" :src="require('@/assets/images/google-play.png')" alt="google play" /></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="aside-box">
            <strong class="h2 text-uppercase">Share on</strong>
            <social-media></social-media>
        </div> 
        <div v-if="match">
            <div class="aside-box">
                <strong class="h2 text-uppercase">match info</strong>
                <ul class="info-match-list highlight">
                    <li>
                        <span class="match-timing">{{ match.gmt_datetime | formatDate }}</span>
                        <ul class="team-info">
                            <li>
                                <span class="team-info-name">{{ match.team1.name }}</span>
                                <span class="team-info-score">{{ match.ht_score || '-' }}</span>
                            </li>
                            <li>
                                <span class="team-info-name">{{ match.team2.name }}</span>
                                <span class="team-info-score">{{ match.at_score || '-' }}</span>
                            </li>
                        </ul>
                        <span class="match-note">{{ match.comment }}</span>
                    </li>
                </ul>
            </div>
            <match-standings></match-standings>
            <upcoming-matches></upcoming-matches>
            <match-highlights></match-highlights>
        </div>
    </aside>
</template>

<script>
    import SocialMedia from './_SocialMedia'
    import MatchStandings from './_Standings'
    import UpcomingMatches from './_Upcoming'
    import MatchHighlights from './_Highlights'


    export default {
        name: 'articleRightSidebar',

        components: {SocialMedia, MatchStandings, UpcomingMatches, MatchHighlights},

        data() {
            return {
                matchId: '',
                match: null
            }
        },

        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {

                if (!this.$route.params.match)
                    return

                this.matchId = this.$route.params.match

                return this.$axios
                        .get(this.$ARTICLE_MATCH_API.replace(':match', this.$route.params.match))
                        .then(response => {
                            this.is_data_ready = true
                            this.match = response.data.result.match
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>

